module.exports = __webpack_public_path__ + "static/media/bottom.d467870f.png";